export const INSPECTIONS_IN_PROGRESS_ERROR_PARTS = [
  'Inspections',
  'are in progress',
] as const;

export const DOCUMENT_LIMIT_EXCEEDED_ERROR_PARTS = [
  'Document count',
  'limit',
] as const;

export const LOCAL_DOCUMENT_ERROR_CODES = {
  LOCAL_DOCUMENT_NOT_FOUND: 'DOCUMENT_LOCAL_NOT_FOUND',
  LOCAL_DOCUMENT_DATA_INACCESSIBLE: 'DOCUMENT_LOCAL_DATA_INACCESSIBLE',
} as const;

export const LOCAL_DOCUMENT_ERROR_MESSAGES = {
  NOT_FOUND_PREFIX: 'Cannot find document with id',
  DATA_INACCESSIBLE: 'Cannot access document data to upload.',
} as const;

export const NON_RETRYABLE_LOCAL_DOCUMENT_UPLOAD_ERROR_CODES = [
  LOCAL_DOCUMENT_ERROR_CODES.LOCAL_DOCUMENT_NOT_FOUND,
  LOCAL_DOCUMENT_ERROR_CODES.LOCAL_DOCUMENT_DATA_INACCESSIBLE,
] as const;

export const SITE_DELETE_CONFLICT_INSPECTIONS_IN_PROGRESS_MESSAGE_ID = 'site_delete_conflict_inspections_in_progress' as const;

export const TOO_MANY_FILES_MESSAGE_ID = 'file_too_many_files' as const;

export const STAGE_NOT_IN_WORKFLOW_ERROR_PARTS = [
  'stage',
  'not found',
] as const;

export const STAGE_NOT_IN_WORKFLOW_MESSAGE_ID =
  'stage_not_in_workflow' as const;

export const STAGE_AWAITING_APPROVALS_ERROR_TYPE = 'AWAITING_APPROVALS' as const;

export const STAGE_AWAITING_APPROVALS_MESSAGE_ID = 'stage_awaiting_approvals' as const;

export const STAGE_REJECTED_ERROR_TYPE = 'STAGE_REJECTED' as const;
/** A link to a documentation (PT-7117) whose documentation has no current version to open. */
export const LINKED_DOCUMENTATION_WITHOUT_CURRENT_VERSION_ERROR_TYPE = 'LINKED_DOCUMENTATION_WITHOUT_CURRENT_VERSION' as const;

export const STAGE_REJECTED_MESSAGE_ID = 'stage_rejected' as const;
/**
 * The backend's 409 when someone else changed the documentation since it was
 * read (PT-7117). It carries no error type: its message tells it from the
 * other conflicts of a documentation.
 */
export const DOCUMENTATION_CHANGED_MEANWHILE_ERROR_PARTS = ['changed by someone else', 'in the meantime'] as const;
/** Someone else changed the documentation meanwhile (409, PT-7117): the queued change was dropped. */
export const DOCUMENTATION_CHANGED_MEANWHILE_MESSAGE_ID = 'documentation_changed_meanwhile' as const;

export const INSPECTION_ANSWERS_NOT_FILLED_ERROR_PARTS = [
  'required answers',
  'must be filled',
] as const;

export const INSPECTION_ANSWERS_NOT_FILLED_MESSAGE_ID =
  'inspection_answers_not_filled_error' as const;

export const EXTENDED_ERROR_TOAST_DELAY = 6000 as const;

/** Backend message ids that need a longer toast (more text to read). */
export const EXTENDED_ERROR_TOAST_MESSAGE_IDS = [
  STAGE_AWAITING_APPROVALS_MESSAGE_ID,
  STAGE_REJECTED_MESSAGE_ID,
  INSPECTION_ANSWERS_NOT_FILLED_MESSAGE_ID,
] as const;
